import { useMediaQuery } from "@mui/material";
import { ReactNode } from "react";
import { Author } from "../../../manifest/models/author.models";
import { ExperimentBranding } from "../../../manifest/models/branding.models";
import { View } from "../../../utils/view";
import { DesktopTopMenu } from "../desktop-menu.component/desktop-menu.component";
import { MenuController, MenuPage, MenuState } from "../menu.controller";
import { MobileTopMenu } from "../mobile-menu.component/mobile-menu.component";
import "./top-menu.component.css";

export interface TopMenuProps {
  controller: MenuController;
  notificationCount: number;
  branding: ExperimentBranding | undefined;
  onlineUsers: Author[];
}

export class TopMenuBar extends View<TopMenuProps, MenuState, MenuController> {
  constructor(props: TopMenuProps) {
    super(props, props.controller);
  }

  render(): ReactNode {
    return (
      <NavigationSizer
        branding={this.props.branding}
        notificationCount={this.props.notificationCount}
        currentPage={this.state.currentPage}
        controller={this.controller}
        onlineUsers={this.props.onlineUsers}
      />
    );
  }
}

export function NavigationSizer(props: {
  branding: ExperimentBranding | undefined;
  notificationCount: number;
  currentPage: MenuPage;
  controller: MenuController;
  onlineUsers: Author[];
}) {
  const largeMode = useMediaQuery(props.controller.mobileCutoffQuery);

  if (largeMode) {
    return (
      <DesktopTopMenu
        branding={props.branding}
        currentPage={props.currentPage}
        notificationCount={props.notificationCount}
        onlineUsers={props.onlineUsers}
      />
    );
  } else {
    return (
      <MobileTopMenu
        branding={props.branding}
        currentPage={props.currentPage}
        notificationCount={props.notificationCount}
      />
    );
  }
}
